module.exports = __webpack_public_path__ + "static/recipe1-7b0efd86768ea67b117cdf66bedbe5ce.svg";